import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { Row, H4, Overline, Paragraph } from '@fs/zion-ui'
import { PersonDuplicates } from '@fs/zion-icon'
import { string } from 'prop-types'

export default function FamilyGroupCardContent({ headingKey, headingFallback, descriptionKey, descriptionFallback }) {
  const [t] = useTranslation()

  return (
    <>
      <Row alignY="middle">
        <H4>
          <Overline>
            <PersonDuplicates role="presentation" />
            <b>&nbsp;{t('familygroups.header.alt', 'Family Groups')}</b>
          </Overline>
          {t(headingKey, headingFallback)}
        </H4>
      </Row>
      <Paragraph size="sm">
        <Trans i18nKey={descriptionKey}>{descriptionFallback}</Trans>
      </Paragraph>
    </>
  )
}

FamilyGroupCardContent.propTypes = {
  headingKey: string.isRequired,
  headingFallback: string.isRequired,
  descriptionKey: string.isRequired,
  descriptionFallback: string.isRequired,
}
